module.exports = __webpack_public_path__ + "img/vegeteteraian.cdd46d49.jpg";